import { makeStyles } from '@mui/styles'
import { defaultPalette } from '../../../theme/idsTheme'
import { makeSx } from '@saas/lib/shared-utils'

export const buttonSx = makeSx({
    secondaryButton: {
        backgroundColor: `${defaultPalette.lightGrey.mediumDark} !important`,
        color: `${defaultPalette.typography.main} !important`,
        boxShadow: 'none',
    },
})

export const workflowTunnelSx = makeSx({
    root: {
        position: 'relative',
        height: '100vh',
        backgroundColor: defaultPalette.lightGrey.main,
        overflow: 'hidden',
    },
    workflowNav: {
        flexShrink: 0,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: defaultPalette.white.main,
        marginBottom: '1.6rem',
        gap: '1rem',
        minHeight: '3.125rem',
        padding: '0.625rem 1rem',
        zIndex: 2,
        boxShadow: `0 2px 4px 0 rgba(221, 225, 236, 0.25), 0 5px 15px 0 ${defaultPalette.lightGrey.harder}`,
    },
    workflowInnerContainer: {
        width: '100%',
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: 'auto',
        paddingX: {
            xs: '1rem',
            lg: 0,
        },
        paddingBottom: { xs: '12rem', md: '6rem' },
        boxSizing: 'border-box',
    },
    actions: {
        width: 'auto',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
    },
    abandonButton: {
        borderRadius: '8px',
        padding: '12px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        color: '#FB355D',
        background: '#FBF4F6',
        display: 'flex',
        '&:hover': {
            background: defaultPalette.red.hover,
            color: defaultPalette.white.main,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '24px',
        },
    },
    resumeButton: {
        display: 'flex',
        height: '52px',
        minWidth: '168px',
        padding: '14px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        borderRadius: '8px',
        background: '#2f3236',
        color: '#ffffff',
        '&:hover': {
            background: defaultPalette.typography.hover,
        },
        '&.Mui-disabled': {
            background: '#E0E0E0',
            color: '#8B8B8B',
            '& svg path': {
                fill: '#8B8B8B',
            },
        },
    },
})

export const recapViewSx = makeSx({
    recapWrapper: {
        width: '100%',
        maxWidth: '760px',
        margin: '0 auto',
        padding: '0 1rem 2rem',
        gap: '2.125rem',
        boxSizing: 'border-box',
        '@media (max-width: 768px)': {
            padding: 0,
        },
    },
    recapTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '2rem',
        lineHeight: '2.5rem',
        color: defaultPalette.typography.main,
        marginBottom: '0.25rem',
        letterSpacing: '0.15px',
    },
    recapSubtitle: {
        color: defaultPalette.typography.light,
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        letterSpacing: '0.15px',
    },
    recapItem: {
        width: '100%',
        gap: '0.75rem',
        padding: 0,
    },
    recapQuestion: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '1.313rem',
        lineHeight: '1.813rem',
        color: defaultPalette.typography.main,
        letterSpacing: '0.15px',
    },
    recapAnswer: {
        width: '100%',
    },
    tooltipContentContainer: {
        display: 'flex',
        padding: '1.625rem 1.5rem',
        gap: '1rem',
        alignSelf: 'stretch',
        borderRadius: '0.75rem',
        cursor: 'not-allowed',
    },
    tooltipContentText: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.15px',
    },
    tooltipContentDisabledFilledContainer: {
        border: '2px solid #555ABE8A',
        backgroundColor: '#F7F7FE',
        background: `linear-gradient(0deg, #F7F7FE 0%, #F7F7FE 100%), #FFF`,
    },
    tooltipContentDisabledFilledText: {
        color: defaultPalette.lightGrey.stepIcon,
    },
    tooltipContentDisabledEmptyContainer: {
        border: '1px solid #E6E7E7',
        backgroundColor: defaultPalette.white.main,
    },
    tooltipContentDisabledEmptyText: {
        color: '#31333661',
        fontStyle: 'italic',
    },
})

export const bottomBarSx = makeSx({
    backButton: {
        display: 'flex',
        padding: '1.125rem 2.125rem 1.125rem 2rem',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.75rem',
        alignSelf: 'stretch',
        borderRadius: '0.5rem',
        color: defaultPalette.typography.main,
        fontFamily: 'AvertaPE-Bold',
        fontSize: '1rem',
        border: 'none',
        '&:disabled': {
            border: 'none',
            '& .MuiButton-icon svg path': {
                fill: defaultPalette.lightGrey.stepIcon,
            },
        },
        '&:hover': {
            background: '#F5F6FA',
            border: 'none',
        },
        '@media (max-width: 768px)': {
            flex: '1',
            padding: '0.625rem 1rem',
        },
    },
})

export default makeStyles((theme) => ({
    workflowNav: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#fff',
        marginBottom: '1.6rem',
        gap: '1rem',
        minHeight: '50px',
        padding: '10px 16px',
        boxShadow: '0 2px 4px 0 rgba(221, 225, 236, 0.25), 0 5px 15px 0 #DDE1EC',
    },
    title: {
        flex: 1,
        width: 'fit-content',
        fontWeight: 600,
        fontSize: '21px',
        lineHeight: '29px',
        fontFamily: 'AvertaPE-Bold',
    },
    helpButton: {
        minWidth: 40,
        height: 34,
        borderRadius: '10000px',
        border: '1.5px solid #313336',
        fontWeight: 700,
    },

    HeaderRightHelpButton: {
        color: defaultPalette.typography.main,
        width: '2.25rem',
        height: '2.25rem',
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: defaultPalette.lightGrey.main,
    },
    progressWrapper: {
        width: '100%',
        maxWidth: '600px',
        margin: '24px auto',
        padding: '0 16px',
    },
    loadingContent: {
        minHeight: '240px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
    },
    questionWrapper: {
        width: '100%',
        maxWidth: '595px',
        margin: '0 auto',
        marginBottom: '1.5rem',
    },
    questionHeader: {
        width: '100%',
    },
    questionSectionLabel: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '22px',
        letterSpacing: '0.2px',
        fontVariant: 'all-small-caps',
        color: '#787AAB',
    },
    questionTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '24px',
        letterSpacing: '0.15px',
        lineHeight: '32px',
        color: '#313336',
    },
    questionHint: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '18px',
        lineHeight: '26px',
        letterSpacing: '0.15px',
        color: '#313336',
        marginTop: '4px',
    },
    content: {
        flex: '1 1 auto',
        paddingBottom: '16px',
    },
    bottomBar: {
        boxSizing: 'border-box',
        position: 'fixed',
        bottom: '0',
        left: 0,
        zIndex: 2,
        width: '100%',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        minHeight: '72px',
        background: '#FCFBFE',
        flexWrap: 'wrap',
        borderTop: '1px solid #E5E9F2',
        boxShadow: '0 -1px 20px 0 rgba(221, 225, 236, 0.22)',
        gap: '34px',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
            padding: '16px',
            gap: '12px',
        },
    },
    leftSection: {
        flex: '1 1 auto',
        minWidth: '200px',
    },
    patientInfo: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '16px',
        color: '#313336',
        fontWeight: 600,
        lineHeight: '24px',
        '@media (max-width: 768px)': {
            fontSize: '13px',
            textAlign: 'center',
        },
    },
    rightSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '16px',
        flex: 1,
        '@media (max-width: 768px)': {
            width: '100%',
            justifyContent: 'space-between',
        },
    },
    backButton: {
        display: 'flex',
        padding: '18px 34px 18px 32px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        color: '#313336',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        border: 'none',
        '&:disabled': {
            border: 'none',
            '& .MuiButton-icon svg path': {
                fill: '#8B8B8B',
            },
        },
        '&:hover': {
            background: '#F5F6FA',
            border: 'none',
        },
        '@media (max-width: 768px)': {
            flex: '1',
            padding: '10px 16px',
        },
    },
    nextButton: {
        display: 'flex',
        width: '168px',
        height: '60px',
        minWidth: '168px',
        padding: '14px 32px 14px 34px',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderRadius: '8px',
        background: '#575BAF',
        '&:hover': {
            background: '#575BAF',
        },
        '@media (max-width: 768px)': {
            flex: '1',
            padding: '10px 16px',
        },
    },
    placeholder: {
        color: '#666',
    },
    deleteText: {
        width: '100%',
        textAlign: 'left',
        alignSelf: 'flex-start',
        marginBottom: '24px',
        marginTop: '-9px',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.15px',
    },
    helpDraftTitle: {
        color: '#313336',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '21px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '29px',
        letterSpacing: '0.15px',
        margin: 0,
    },
    helpDialogPaper: {
        width: '100%',
        maxWidth: '588px',
        margin: '0 auto',
        borderRadius: '24px',
        '@media (max-width:700px)': {
            margin: '16px',
            width: 'calc(100% - 32px)',
            borderRadius: '16px',
        },
    },
    dialogPaperNoScroll: {
        overflow: 'hidden',
        '& .MuiDialogContent-root': {
            overflow: 'hidden',
        },
    },
    transmissionContainer: {
        flex: 1,
        width: '100%',
        maxWidth: '34.625rem',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        minHeight: '400px',
        padding: '40px 16px',
    },
    transmissionStatusIcon: {
        fontSize: '48px',
    },
    transmissionTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '32px',
        lineHeight: '40px',
        color: '#313336',
        textAlign: 'center',
    },
    transmissionSubtitle: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '18px',
        lineHeight: '26px',
        color: '#313336',
        textAlign: 'center',
        marginTop: '-0.6rem',
        fontWeight: 400,
    },
    warningIconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '7.75rem',
        height: '7.75rem',
        borderRadius: '50%',
        backgroundColor: defaultPalette.orangeWarning.light,
    },
    warningIcon: {
        fontSize: '4.5rem',
        color: defaultPalette.orangeWarning.main,
    },
    transmissionProgressWrapper: {
        width: '100%',
        maxWidth: '400px',
    },
    retryButton: {
        display: 'flex',
        padding: '16px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        background: '#FB355D',
        color: '#fff',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '16px',
        '&:hover': {
            background: '#f74a6d',
        },
    },
    transmissionErrorTitle: {
        fontFamily: 'AvertaPE-Bold',
        fontSize: '32px',
        lineHeight: '40px',
        color: '#313336',
        textAlign: 'center',
    },
    progressContainer: {
        width: '100%',
    },
    progressContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
    },
    progressLabelWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    progressLabel: {
        fontWeight: 700,
        fontSize: '16px',
        textAlign: 'center',
    },
    progressLabelError: {
        color: '#FB355D',
    },
    progressLabelSuccess: {
        color: '#575BAF',
    },
    progressBarWrapper: {
        width: '100%',
    },
    progressBar: {
        height: 8,
        borderRadius: 800,
        backgroundColor: '#D8DBF2',
        '& .MuiLinearProgress-bar': {
            borderRadius: 100,
            transition: 'transform 0.4s linear',
        },
    },
    progressBarError: {
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#FB355D',
        },
    },
    progressBarSuccess: {
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#6E72D8',
        },
    },
}))
